import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import OptionSection from 'src/js/modules/common/components/option-section';
import { INDETERMINATE } from '../constants/common';
import ElementSettingsContext from '../helpers/element-settings-context';
import getBatchValues from '../helpers/get-batch-values';

const { Box, ActionRadioGroup } = designSystem;

function ActionRadioGroupControl({
  id,
  elementIds,
  attributes,
  title,
  choices,
  popover = null,
  nested = false,
  onChange,
}) {
  const { state } = useContext(ElementSettingsContext);

  const flattenedValues = getBatchValues(state, {
    elementIds,
    attributes,
  }).flat();
  const selectedValue = flattenedValues[0];
  const isIndeterminate = !flattenedValues.every((value) => value === selectedValue);
  const selectedId = isIndeterminate
    ? INDETERMINATE
    : choices.find((choice) => choice.value === selectedValue)?.id || '';

  const handleChange = useCallback(
    ({ value }) => {
      onChange({ controlId: id, elementIds, attributes, value });
    },
    [id, elementIds, attributes, onChange]
  );

  return (
    <Box
      {...(!nested && {
        paddingTop: 'spacing-xs',
        paddingBottom: 'spacing-s',
        paddingLeft: 'spacing-m',
        paddingRight: 'spacing-m',
      })}
    >
      <OptionSection title={title} popoverProps={popover} bold={!nested}>
        <ActionRadioGroup selectedId={selectedId} options={choices} onChange={handleChange} />
      </OptionSection>
    </Box>
  );
}

ActionRadioGroupControl.propTypes = {
  id: PropTypes.string.isRequired,
  elementIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributes: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  choices: PropTypes.array.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string,
    imgSrc: PropTypes.string,
  }),
  nested: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default ActionRadioGroupControl;
